export default {
  clientID: 'AlMurabaCMS_App',
  tokenSchema: '/connect',
  apiSchema: '/api',
  // baseURL: 'https://localhost:44334',
  baseURL: 'https://apiweb.vsi.org.iq',
};
